export default __webpack_public_path__ + "static/media/ANZOR_logo.c0980c68.svg";